module.exports = __webpack_public_path__ + "static/media/similar.434e7e68.png";